import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

var FEATURES = [
  { icon:'🧾', title:'Bilty & LR Generation',  desc:'Professional Lorry Receipts in seconds. 3-copy print — Original, Consignor, Consignee.', color:'#f0fdf4', border:'#bbf7d0' },
  { icon:'📦', title:'Trip Management',          desc:'Full trip lifecycle — assign truck, driver, track from created to POD received.', color:'#eff6ff', border:'#bfdbfe' },
  { icon:'📒', title:'Party Ledger',             desc:'Auto-track what every party owes. Payments, advances, balances always updated.', color:'#faf5ff', border:'#ddd6fe' },
  { icon:'👤', title:'Driver Management',        desc:'Track driver advances, payments, trip history. Know exactly who owes what.', color:'#fff7ed', border:'#fed7aa' },
  { icon:'🚛', title:'Fleet Tracking',           desc:'Own trucks + market trucks. Full vehicle history and maintenance records.', color:'#f0fdf4', border:'#bbf7d0' },
  { icon:'📊', title:'Reports & Analytics',      desc:'Daily, monthly profit reports. Know your earnings and pending payments.', color:'#eff6ff', border:'#bfdbfe' },

  /* The three that were missing. A broker looking at this page wants
     to know whether the software does the paperwork on both sides —
     the bill they send the party and the challan they hand the truck
     owner — and whether it will keep their bank straight for the CA. */
  { icon:'🧮', title:'GST Invoices',             desc:'Bill a party for many trips at once. GST, due dates, part payments — with an annexure listing every LR.', color:'#faf5ff', border:'#ddd6fe' },
  { icon:'📑', title:'Supplier Challans',        desc:'What you owe each truck owner, trip by trip. Hire less deductions and advances, with the balance always right.', color:'#fff7ed', border:'#fed7aa' },
  { icon:'🏦', title:'Bank & Cash Accounts',     desc:'Tag every payment to an account. Download a statement in Excel with the LR number on each line — ready for your CA.', color:'#f0fdf4', border:'#bbf7d0' },
];

var STEPS = [
  { n:'01', title:'Register Free',    desc:'Sign up with your mobile number. 15-day free trial starts instantly.' },
  { n:'02', title:'Add Your Data',    desc:'Add parties, trucks, drivers. Guided setup takes less than 5 minutes.' },
  { n:'03', title:'Create First Trip',desc:'Create trip, assign truck & driver, generate LR — all in 2 minutes.' },
  { n:'04', title:'Track Everything', desc:'Monitor payments, generate bilty, view ledger, download reports.' },
];

var TESTIMONIALS = [
  { name:'Rajesh Agarwal',   city:'Delhi',     role:'Transport Broker',  text:'Been using for 8 months. Bilty generation saved us 2 hours daily. Party ledger is spot on.', stars:5 },
  { name:'Suresh Logistics', city:'Mumbai',    role:'Transporter',       text:'Track 50+ trucks with zero confusion. Driver payment tracking is a game changer.', stars:5 },
  { name:'Priya Transport',  city:'Bangalore', role:'Fleet Owner',       text:'My accountant loves the reports. Export to Excel works perfectly. Very professional.', stars:5 },
];

var FAQS = [
  { q:'Is it free to use?',              a:'Yes! 15-day free trial with all features. No credit card needed.' },
  { q:'Can I use it on mobile?',         a:'Absolutely. Fully mobile-responsive. Works perfectly on Android and iOS.' },
  { q:'How many users can I add?',       a:'Unlimited staff with custom permissions — control view, add, edit, delete.' },
  { q:'Is my data secure?',             a:'Yes. All data encrypted. Each broker account completely isolated.' },
  { q:'Can I print Bilty/LR?',          a:'Yes. Professional Bilty with 3 copies. Print or share as PDF via email.' },
  { q:'Do you support email?',           a:'Yes. Send trip bills, LR copies via email with PDF attachment.' },
];

var PRICING = [
  { name:'Free Trial', price:'₹0',   period:'15 days',   highlight:false, cta:'Start Free',  features:['All features included','Unlimited trips','Bilty & LR print','Email support'] },
  { name:'Professional', price:'₹499', period:'per month', highlight:true,  cta:'Get Started', features:['Everything in Trial','Unlimited users','Priority support','Custom branding','Data export Excel'] },
  { name:'Enterprise', price:'Custom', period:'per year',  highlight:false, cta:'Contact Us',  features:['Everything in Pro','Dedicated support','API access','Custom integration','SLA guarantee'] },
];


/* Google Analytics event — GA na laga ho toh chup-chaap kuch nahi karta */
function track(name, params) {
  try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); }
  catch (e) { /* ignore */ }
}

export default function LoginPage() {
  var { login, register } = useAuth();
  var navigate    = useNavigate();
  var [popup,    setPopup]   = useState(false);
  var [tab,      setTab]     = useState('login'); // 'login' | 'register'
  var [phone,    setPhone]   = useState('');
  var [password, setPassword]= useState('');
  var [showPass, setShowPass]= useState(false);
  var [expired,  setExpired] = useState(null);

  /* Plans come from the database so super admin can change price
     and run offers without a rebuild. If the request fails the
     hardcoded PRICING list is used, so the page never breaks. */
  var [plans, setPlans] = useState(null);
  useEffect(function () {
    var alive = true;
    fetch('/api/plans')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (alive && j && j.data && j.data.length) setPlans(j.data);
      })
      .catch(function () { /* keep the fallback */ });
    return function () { alive = false; };
  }, []);

  /* ── App install ──────────────────────────────────────────────
     Chrome install se pehle 'beforeinstallprompt' bhejta hai. Use
     rok ke rakhte hain, aur user ke button dabane par dikhate hain.
     iOS me Apple aisa koi API deta hi nahi, isliye wahan steps
     dikhane padte hain — aur koi rasta nahi hai.               */
  var [deferred, setDeferred] = useState(null);
  var [installed, setInstalled] = useState(false);
  var [showIosHelp, setShowIosHelp] = useState(false);

  /* Two things this used to get wrong.

     An iPad on iPadOS 13 and later reports itself as a Macintosh —
     Apple did that so sites would serve the desktop layout. So a
     userAgent test for "ipad" never matches one, and the iPad fell
     through to a message about a Chrome menu that is not there. The
     touch-point count is what separates a real Mac from an iPad.

     And Chrome or Firefox on an iPhone was treated as "not iOS", so
     it got the same Chrome-menu message — but no browser on iOS
     except Safari can install a web app at all. It needs its own
     answer, not the Android one. */
  var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  var isIosDevice = /iphone|ipad|ipod/i.test(ua) ||
                    (/macintosh/i.test(ua) && typeof navigator !== 'undefined' &&
                     ((navigator.maxTouchPoints || 0) > 0 ||
                      (typeof document !== 'undefined' && 'ontouchend' in document)));
  var isIosSafari = isIosDevice && !/crios|fxios|edgios|opt\//i.test(ua);
  var isIos = isIosSafari;

  useEffect(function () {
    function alreadyInstalled() {
      return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
             window.navigator.standalone === true;
    }
    if (alreadyInstalled()) setInstalled(true);

    function onPrompt(e) { e.preventDefault(); setDeferred(e); }
    function onInstalled() { setInstalled(true); setDeferred(null); toast.success('App install ho gaya!'); }

    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return function () {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  async function installApp() {
    if (isIosSafari) { setShowIosHelp(true); return; }

    /* Chrome, Firefox and Edge on an iPhone cannot install a web app —
       only Safari can. Telling someone to look for an install item in
       a menu that has none just wastes their time. */
    if (isIosDevice) {
      toast('Open in Safari — on iPhone the app can only be installed from Safari.',
        { icon: '🧭', duration: 6000 });
      return;
    }

    if (!deferred) {
      toast('Open the browser menu (⋮) and choose "Install app"', { icon: 'ℹ️', duration: 5000 });
      return;
    }
    deferred.prompt();
    try {
      var choice = await deferred.userChoice;
      track('app_install_prompt', { outcome: choice && choice.outcome });
    } catch (e) { /* ignore */ }
    setDeferred(null);
  }
  var [name,     setName]    = useState('');
  var [company,  setCompany] = useState('');
  var [loading,  setLoading] = useState(false);
  var [error,    setError]   = useState('');
  var [faqOpen,  setFaqOpen] = useState(null);

  var open  = useCallback(function(t){ track('signup_started', { tab: t || 'login' }); setPopup(true); setTab(t||'login'); setError(''); setExpired(null); setPhone(''); setPassword(''); setName(''); setCompany(''); }, []);
  var close = useCallback(function(){ setPopup(false); }, []);

  // Popup open ho toh: Escape se band, background scroll lock, band hone pe focus wapas
  useEffect(function(){
    if(!popup) return undefined;
    var opener = document.activeElement;
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function onKey(e){ if(e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    return function(){
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
      if(opener && typeof opener.focus === 'function') opener.focus();
    };
  }, [popup, close]);

  async function handleLogin(e) {
    e.preventDefault();
    if(!phone || !password){ setError('Phone and password are required.'); return; }
    setLoading(true); setError('');
    try {
      var res = await login(phone, password);
      var u   = res && res.user;

      // If the trial or subscription has run out, say so plainly
      if (u && u.subscription_expires && u.subscription_plan !== 'lifetime') {
        var dl = Math.ceil((new Date(u.subscription_expires) - new Date()) / 86400000);
        /* Expired accounts now sign in read-only: they can see their
           data, the red bar at the top asks them to renew, and the
           server refuses changes. So they go to the dashboard too. */
        if (dl < 0) {
          toast.error((u.subscription_plan === 'trial' ? 'Your free trial has ended' : 'Your plan has expired')
            + ' — you can view your data. Take a paid plan to add or edit.', { duration: 6000 });
          navigate('/dashboard');
          return;
        }
      }
      toast.success('Welcome back! 🚛');
      /* The app's home is /dashboard now; "/" is the landing page,
         which is not where someone who just signed in wants to be. */
      navigate('/dashboard');
    } catch(err) {
      var msg = err.response?.data?.message || 'Login failed. Check credentials.';
      setError(msg);
    } finally { setLoading(false); }
  }

  async function handleRegister(e) {
    e.preventDefault();
    if(!phone || !password || !name){ setError('Name, phone and password are required.'); return; }
    if(password.length < 6){ setError('Password must be at least 6 characters.'); return; }
    setLoading(true); setError('');
    try {
      await register({ name, phone, password, company_name: company, role:'admin' });
      track('sign_up', { method: 'phone' });
      await login(phone, password);
      toast.success('Account created! Welcome 🎉');
      navigate('/profile?welcome=1');
    } catch(err) {
      setError(err.response?.data?.message || 'Registration failed. Try again.');
    } finally { setLoading(false); }
  }

  var INP = { width:'100%', padding:'13px 16px', borderRadius:'10px', border:'1.5px solid #e5e7eb', fontSize:'14px', outline:'none', boxSizing:'border-box', fontFamily:'inherit', color:'#111827', transition:'border-color 0.15s', background:'#fff' };
  var BTN_G = { width:'100%', padding:'14px', borderRadius:'10px', border:'none', color:'#fff', fontSize:'15px', fontWeight:'800', cursor:'pointer', background:'linear-gradient(135deg,#16a34a,#15803d)', boxShadow:'0 4px 16px rgba(22,163,74,0.3)', transition:'opacity 0.2s' };
  var LBL = { display:'block', fontSize:'11px', fontWeight:'700', color:'#374151', textTransform:'uppercase', letterSpacing:'0.4px', marginBottom:'6px' };

  return (
    <div style={{ fontFamily:"'Inter',-apple-system,sans-serif", color:'#111827', background:'#fff', overflowX:'hidden' }}>

      {/* ═══ NAVBAR ═══ */}
      <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:999, background:'rgba(255,255,255,0.96)', backdropFilter:'blur(12px)', borderBottom:'1px solid rgba(0,0,0,0.07)', height:'64px', display:'flex', alignItems:'center', padding:'0 5%' }}>
        <div style={{ maxWidth:'1200px', width:'100%', margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'10px', minWidth:0 }} className="nav-brand-lp">
            <div style={{ width:'38px', height:'38px', flexShrink:0, borderRadius:'10px', background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'20px' }}>🚛</div>
            <div>
              <div style={{ fontSize:'16px', fontWeight:'900', color:'#111827', lineHeight:1.1, whiteSpace:'nowrap' }} className="nav-name-lp">
                Transport<span style={{ color:'#15803d' }}>Master</span>
              </div>
              <div style={{ fontSize:'9px', color:'#6b7280', fontWeight:'600', letterSpacing:'0.3px', whiteSpace:'nowrap' }} className="nav-tag-lp">For Brokers &amp; Transporters</div>
            </div>
          </div>
          <div style={{ display:'flex', gap:'24px', alignItems:'center' }} className="nav-links-lp">
            <a href="/blog" style={{ display:'inline-flex', alignItems:'center', minHeight:'44px', fontSize:'13px', fontWeight:'600', color:'#374151', textDecoration:'none' }}>Blog</a>
            {['Features','Pricing','FAQ'].map(function(l){ return (
              <a key={l} href={'#'+l.toLowerCase()} style={{ display:'inline-flex', alignItems:'center', minHeight:'44px', fontSize:'13px', fontWeight:'600', color:'#374151', textDecoration:'none' }}
                onMouseEnter={function(e){e.target.style.color='#16a34a';}} onMouseLeave={function(e){e.target.style.color='#374151';}}>
                {l}
              </a>
            );})}
          </div>
          <div style={{ display:'flex', gap:'8px', flexShrink:0 }} className="nav-cta-lp">
            <button onClick={function(){ open('login'); }} style={{ padding:'9px 16px', minHeight:'40px', whiteSpace:'nowrap', borderRadius:'8px', border:'1.5px solid #e5e7eb', background:'#fff', color:'#374151', fontSize:'13px', fontWeight:'700', cursor:'pointer' }}>Login</button>
            <button onClick={function(){ open('register'); }} style={{ padding:'9px 16px', minHeight:'40px', whiteSpace:'nowrap', borderRadius:'8px', border:'none', background:'linear-gradient(135deg,#16a34a,#15803d)', color:'#fff', fontSize:'13px', fontWeight:'700', cursor:'pointer', boxShadow:'0 3px 10px rgba(22,163,74,0.3)' }}>Free Trial 🚀</button>
          </div>
        </div>
      </nav>

      {/* ═══ HERO ═══ */}
      <section style={{ paddingTop:'64px', minHeight:'100vh', background:'linear-gradient(160deg,#f0fdf4 0%,#fff 55%,#eff6ff 100%)', display:'flex', alignItems:'center' }} className="hero-sec-lp">
        <div style={{ maxWidth:'1200px', margin:'0 auto', padding:'48px 5%', width:'100%', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'48px', alignItems:'center' }} className="hero-grid-lp">
          <div>
            <div style={{ display:'inline-flex', alignItems:'center', gap:'6px', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'20px', padding:'5px 12px', fontSize:'11px', fontWeight:'700', color:'#15803d', marginBottom:'20px' }}>
              🇮🇳 Made in India · Trusted by 10,000+ businesses
            </div>
            <h1 style={{ fontSize:'44px', fontWeight:'900', color:'#111827', lineHeight:1.1, marginBottom:'16px', letterSpacing:'-1px' }}>
              India's #1<br/>
              <span style={{ background:'linear-gradient(135deg,#16a34a,#22c55e)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>Transport</span> Software<br/>
              <span style={{ fontSize:'28px', color:'#374151', fontWeight:'700' }}>for Brokers &amp; Transporters</span>
            </h1>
            <p style={{ fontSize:'15px', color:'#6b7280', lineHeight:1.75, marginBottom:'28px' }}>
              Create <strong style={{ color:'#111827' }}>LR/Bilty</strong>, manage <strong style={{ color:'#111827' }}>trips</strong>, track <strong style={{ color:'#111827' }}>driver payments</strong> &amp; party ledger — all from one platform.
            </p>
            <div style={{ display:'flex', gap:'10px', marginBottom:'24px', flexWrap:'wrap' }} className="hero-cta-lp">
              <button onClick={function(){ open('register'); }} style={{ padding:'13px 24px', borderRadius:'10px', background:'linear-gradient(135deg,#16a34a,#15803d)', border:'none', color:'#fff', fontSize:'14px', fontWeight:'800', cursor:'pointer', whiteSpace:'nowrap', boxShadow:'0 6px 20px rgba(22,163,74,0.35)' }}>
                Start Free Trial →
              </button>
              <button onClick={function(){ open('login'); }} style={{ padding:'13px 20px', borderRadius:'10px', border:'1.5px solid #e5e7eb', background:'#fff', color:'#374151', fontSize:'14px', fontWeight:'700', cursor:'pointer', whiteSpace:'nowrap' }}>
                Login
              </button>
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'12px' }}>
              {['✅ 15-day free trial','📱 Mobile friendly','🔒 Secure','⚡ 2-min setup'].map(function(b){ return (
                <span key={b} style={{ fontSize:'11px', color:'#6b7280', fontWeight:'600' }}>{b}</span>
              );})}
            </div>
          </div>

          {/* Dashboard mockup */}
          {/* A picture of the app, drawn in HTML. Screen readers should
              read the label, not the forty fragments of 6px text inside
              it — and a contrast checker should not grade a screenshot
              as body copy. */}
          <div style={{ position:'relative' }} className="hero-mockup-lp"
            role="img"
            aria-label="The TransportMaster trip screen: trip TP247 from Delhi to Mumbai, ₹5,500 to receive from the party, ₹2,900 to pay the truck owner, ₹2,600 net profit, with the same trip open on a phone.">
            {/* Laptop. The browser window on its own read as "a screen"
                and nothing more; with a lid and a base beside a phone,
                the pair says desktop and mobile without a caption. */}
            <div style={{ background:'#1f2937', borderRadius:'12px 12px 4px 4px', padding:'9px 9px 0',
              boxShadow:'0 24px 70px rgba(15,23,42,0.2)' }}>
            <div style={{ background:'#fff', borderRadius:'8px 8px 0 0', overflow:'hidden', border:'1px solid #eceff2' }}>
              <div style={{ background:'#f6f8fa', padding:'9px 13px', borderBottom:'1px solid #e8ecef', display:'flex', alignItems:'center', gap:'6px' }}>
                {['#ff5f57','#febc2e','#28c840'].map(function(c){ return <div key={c} style={{ width:'9px',height:'9px',borderRadius:'50%',background:c }}/>; })}
                <div style={{ flex:1, background:'#fff', borderRadius:'5px', padding:'3px 10px', fontSize:'9.5px', color:'#6b7280', border:'1px solid #e8ecef', textAlign:'center', marginLeft:'6px' }}>
                  🔒 transportmaster.in/trips/TP247
                </div>
              </div>

              <div style={{ display:'flex', background:'#f4f6f8', minHeight:'320px' }}>
                {/* Sidebar */}
                <div className="mock-side" style={{ width:'112px', flexShrink:0, background:'#0f172a', padding:'11px 8px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'6px', marginBottom:'12px', paddingLeft:'3px' }}>
                    <div style={{ width:'20px', height:'20px', borderRadius:'6px', background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px' }}>🚛</div>
                    <span style={{ fontSize:'9.5px', fontWeight:'800', color:'#fff' }}>TransportMaster</span>
                  </div>
                  {[['📊','Dashboard',0],['📦','Trips',1],['🏢','Parties',0],['🚚','Suppliers',0],['💳','Payments',0],['📒','Ledger',0],['🧾','Invoices',0],['📈','Reports',0]].map(function(m){
                    return (
                      <div key={m[1]} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'5px 6px', borderRadius:'6px', marginBottom:'2px',
                        background: m[2] ? 'rgba(34,197,94,0.16)' : 'transparent' }}>
                        <span style={{ fontSize:'9px' }}>{m[0]}</span>
                        <span style={{ fontSize:'9px', fontWeight: m[2]?'700':'500', color: m[2] ? '#4ade80' : 'rgba(255,255,255,0.55)' }}>{m[1]}</span>
                      </div>
                    );
                  })}
                </div>

                {/* Main area */}
                <div style={{ flex:1, minWidth:0, padding:'11px' }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'9px', gap:'8px' }}>
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontSize:'12px', fontWeight:'900', color:'#111827' }}>TP247 · Delhi → Mumbai</div>
                      <div style={{ fontSize:'8.5px', color:'#6b7280' }}>Shree Sai Carriers · MS Coils · 18.5 T</div>
                    </div>
                    <span style={{ flexShrink:0, fontSize:'8px', fontWeight:'800', background:'#dcfce7', color:'#15803d', padding:'2px 7px', borderRadius:'20px' }}>DELIVERED</span>
                  </div>

                  {/* Payment cards */}
                  <div className="mock-two" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'7px', marginBottom:'7px' }}>
                    <div style={{ background:'#fff', borderRadius:'8px', padding:'8px 9px', border:'1px solid #eceff2' }}>
                      <div style={{ fontSize:'7.5px', fontWeight:'700', color:'#6b7280', textTransform:'uppercase' }}>Party — to receive</div>
                      <div style={{ fontSize:'14px', fontWeight:'900', color:'#dc2626', marginTop:'1px' }}>₹5,500</div>
                      <div style={{ fontSize:'7.5px', color:'#6b7280' }}>of ₹85,500</div>
                    </div>
                    <div style={{ background:'#fff', borderRadius:'8px', padding:'8px 9px', border:'1px solid #eceff2' }}>
                      <div style={{ fontSize:'7.5px', fontWeight:'700', color:'#6b7280', textTransform:'uppercase' }}>Truck owner — to pay</div>
                      <div style={{ fontSize:'14px', fontWeight:'900', color:'#c2410c', marginTop:'1px' }}>₹2,900</div>
                      <div style={{ fontSize:'7.5px', color:'#6b7280' }}>after ₹2,100 commission</div>
                    </div>
                  </div>

                  {/* Profit strip */}
                  <div style={{ background:'linear-gradient(135deg,#f0fdf4,#ecfdf5)', border:'1px solid #bbf7d0', borderRadius:'8px', padding:'8px 10px', marginBottom:'7px',
                    display:'flex', alignItems:'center', justifyContent:'space-between', gap:'8px' }}>
                    <div style={{ fontSize:'8px', color:'#166534', lineHeight:1.5, minWidth:0 }}>
                      <b>Net Profit</b><br/>85,500 − 85,000 + 2,100
                    </div>
                    <div style={{ fontSize:'17px', fontWeight:'900', color:'#15803d', flexShrink:0 }}>₹2,600</div>
                  </div>

                  {/* Trip rows */}
                  {[['TP246','Jaipur → Surat','#dbeafe','#1d4ed8','In transit'],
                    ['TP245','Agra → Kanpur','#fef3c7','#92400e','POD due']].map(function(r){
                    return (
                      <div key={r[0]} style={{ background:'#fff', borderRadius:'8px', padding:'7px 9px', marginBottom:'5px', border:'1px solid #eceff2',
                        display:'flex', alignItems:'center', justifyContent:'space-between', gap:'8px' }}>
                        <div style={{ minWidth:0 }}>
                          <span style={{ fontSize:'8px', fontWeight:'800', color:'#6b7280' }}>{r[0]}</span>
                          <div style={{ fontSize:'9.5px', fontWeight:'700', color:'#111827' }}>{r[1]}</div>
                        </div>
                        <span style={{ flexShrink:0, fontSize:'7.5px', fontWeight:'800', background:r[2], color:r[3], padding:'2px 7px', borderRadius:'20px' }}>{r[4]}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Floating bilty card */}
            <div className="mock-float" style={{ position:'absolute', top:'-26px', left:'-56px', background:'#fff', borderRadius:'11px',
              boxShadow:'0 14px 34px rgba(15,23,42,0.18)', padding:'9px 13px', display:'flex', alignItems:'center', gap:'9px', border:'1px solid #f0f2f4' }}>
              <div style={{ width:'28px', height:'28px', borderRadius:'8px', background:'#f0fdf4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px' }}>📄</div>
              <div>
                <div style={{ fontSize:'10.5px', fontWeight:'800', color:'#111827' }}>Bilty ready</div>
                <div style={{ fontSize:'8.5px', color:'#15803d', fontWeight:'600' }}>3 copies · print or WhatsApp</div>
              </div>
            </div>

            {/* Laptop base — the wedge under the screen */}
            </div>
            <div style={{ height:'11px', background:'#1f2937', borderRadius:'0 0 4px 4px',
              margin:'0 auto', width:'100%' }}/>
            <div style={{ height:'8px', background:'#111827', borderRadius:'0 0 12px 12px',
              width:'118%', marginLeft:'-9%' }}/>

            {/* Phone, standing beside the laptop.

                The earlier version came out 156x170 — a 1:1.09 box,
                which is a tablet, not a phone. Real handsets are close
                to 1:2, so this one is narrower and carries enough rows
                to actually fill that height. */}
            <div className="mock-phone" style={{ position:'absolute', bottom:'-58px', left:'-52px',
              width:'138px', background:'#111827', borderRadius:'22px', padding:'6px',
              border:'2px solid #1f2937',
              boxShadow:'0 26px 56px rgba(15,23,42,0.34)' }}>
              <div style={{ position:'absolute', top:'11px', left:'50%', transform:'translateX(-50%)',
                width:'42px', height:'4px', background:'#1f2937', borderRadius:'4px', zIndex:2 }}/>

              <div style={{ background:'#fff', borderRadius:'17px', overflow:'hidden' }}>

                <div style={{ background:'#111827', padding:'7px 9px 5px', display:'flex',
                  justifyContent:'space-between', alignItems:'center' }}>
                  <span style={{ fontSize:'6px', color:'rgba(255,255,255,0.85)', fontWeight:'700' }}>9:41</span>
                  <span style={{ fontSize:'6px', color:'rgba(255,255,255,0.85)' }}>▮▮▮ 89%</span>
                </div>

                <div style={{ background:'#16a34a', padding:'7px 9px' }}>
                  <div style={{ fontSize:'7px', fontWeight:'800', color:'#fff' }}>🚛 TP247</div>
                  <div style={{ fontSize:'6px', color:'rgba(255,255,255,0.85)' }}>Delhi → Mumbai</div>
                </div>

                <div style={{ padding:'7px 9px', background:'#f9fafb' }}>
                  {[['Party','₹85,500','#111827'],
                    ['Truck hire','₹85,000','#dc2626'],
                    ['Commission','+₹2,100','#15803d'],
                    ['Advance','₹80,000','#6b7280'],
                    ['To receive','₹5,500','#111827'],
                    ['To pay','₹2,900','#dc2626']].map(function(r){
                    return (
                      <div key={r[0]} style={{ display:'flex', justifyContent:'space-between',
                        alignItems:'center', padding:'2.5px 0' }}>
                        <span style={{ fontSize:'6px', color:'#6b7280' }}>{r[0]}</span>
                        <span style={{ fontSize:'6.5px', fontWeight:'800', color:r[2] }}>{r[1]}</span>
                      </div>
                    );
                  })}
                  <div style={{ marginTop:'4px', background:'#f0fdf4', borderRadius:'5px',
                    padding:'5px 7px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span style={{ fontSize:'6px', fontWeight:'700', color:'#15803d' }}>Profit</span>
                    <span style={{ fontSize:'9px', fontWeight:'900', color:'#15803d' }}>₹2,600</span>
                  </div>

                  <div style={{ marginTop:'5px', background:'#16a34a', borderRadius:'5px',
                    padding:'5px 0', textAlign:'center' }}>
                    <span style={{ fontSize:'6px', fontWeight:'800', color:'#fff' }}>🖨️ Print Bilty</span>
                  </div>

                  <div style={{ marginTop:'6px' }}>
                    {[['TP246','Jaipur → Surat'],['TP245','Agra → Kanpur']].map(function(t){
                      return (
                        <div key={t[0]} style={{ background:'#fff', borderRadius:'4px',
                          padding:'4px 6px', marginBottom:'3px', border:'1px solid #f0f2f4' }}>
                          <div style={{ fontSize:'5.5px', color:'#6b7280' }}>{t[0]}</div>
                          <div style={{ fontSize:'6px', fontWeight:'700', color:'#374151' }}>{t[1]}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div style={{ display:'flex', borderTop:'1px solid #f0f2f4', background:'#fff' }}>
                  {['📊','📦','💳','📒'].map(function(ic, i){
                    return (
                      <div key={ic} style={{ flex:1, textAlign:'center', padding:'5px 0',
                        fontSize:'7.5px', opacity: i===1 ? 1 : 0.35 }}>{ic}</div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Floating payment card */}
            <div className="mock-float" style={{ position:'absolute', top:'42px', right:'-20px', background:'#fff', borderRadius:'11px',
              boxShadow:'0 14px 34px rgba(15,23,42,0.18)', padding:'9px 13px', border:'1px solid #f0f2f4' }}>
              <div style={{ fontSize:'8px', fontWeight:'700', color:'#6b7280', textTransform:'uppercase' }}>Payment received</div>
              <div style={{ fontSize:'14px', fontWeight:'900', color:'#15803d' }}>+ ₹80,000</div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ STATS ═══ */}
      <section style={{ background:'linear-gradient(135deg,#16a34a,#15803d)', padding:'40px 5%' }}>
        <div style={{ maxWidth:'1000px', margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px', textAlign:'center' }} className="stats-grid-lp">
          {[{n:'10,000+',l:'Businesses',i:'🏢'},{n:'5 Lakh+',l:'Trips Managed',i:'📦'},{n:'₹500 Cr+',l:'Freight Tracked',i:'💰'},{n:'4.8 ★',l:'Rating',i:'⭐'}].map(function(s){ return (
            <div key={s.l}>
              <div style={{ fontSize:'24px', marginBottom:'4px' }}>{s.i}</div>
              <div style={{ fontSize:'26px', fontWeight:'900', color:'#fff' }}>{s.n}</div>
              <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.8)', fontWeight:'600', marginTop:'2px' }}>{s.l}</div>
            </div>
          );})}
        </div>
      </section>

      {/* ═══ FEATURES ═══ */}
      <section id="features" style={{ padding:'72px 5%', background:'#fff' }}>
        <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'44px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ Everything You Need</div>
            <h2 style={{ fontSize:'34px', fontWeight:'900', color:'#111827', letterSpacing:'-0.5px', marginBottom:'10px' }}>Built for Indian Transport Business</h2>
            <p style={{ fontSize:'15px', color:'#6b7280', maxWidth:'480px', margin:'0 auto', lineHeight:1.7 }}>Every feature designed keeping Indian transport workflow in mind</p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px' }} className="features-grid-lp">
            {FEATURES.map(function(f){ return (
              <div key={f.title} style={{ padding:'22px', borderRadius:'14px', border:'1px solid '+f.border, background:f.color, transition:'all 0.2s' }}
                onMouseEnter={function(e){ e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 10px 32px rgba(0,0,0,0.08)'; }}
                onMouseLeave={function(e){ e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none'; }}>
                <div style={{ fontSize:'28px', marginBottom:'12px' }}>{f.icon}</div>
                <h3 style={{ fontSize:'15px', fontWeight:'800', color:'#111827', marginBottom:'7px' }}>{f.title}</h3>
                <p style={{ fontSize:'12px', color:'#6b7280', lineHeight:1.6 }}>{f.desc}</p>
              </div>
            );})}
          </div>
        </div>
      </section>

      {/* ═══ APP INSTALL ═══ */}
      {!installed && (
      <section id="app" style={{ background:'linear-gradient(160deg,#f0fdf4 0%,#fff 60%,#eff6ff 100%)', padding:'56px 5%', borderTop:'1px solid #f1f5f9' }}>
        <div className="app-wrap-lp" style={{ maxWidth:'1080px', margin:'0 auto', display:'grid', gridTemplateColumns:'0.85fr 1.15fr', gap:'40px', alignItems:'center' }}>

          {/* ── Phone mockup ── */}
          {/* Same reasoning as the hero: a drawing of the app, not text
              anyone is meant to read at 8px. */}
          <div className="app-phone-lp" style={{ display:'flex', justifyContent:'center' }}
            role="img"
            aria-label="The TransportMaster dashboard on a phone: 12 active trips, ₹1.38 lakh to receive, ₹92,500 to pay, ₹74,300 profit, and a list of recent trips.">
            <div style={{ width:'232px', height:'468px', borderRadius:'34px', background:'#111827', padding:'9px',
              boxShadow:'0 22px 50px -14px rgba(15,23,42,0.42)', flexShrink:0 }}>
              <div style={{ width:'100%', height:'100%', borderRadius:'27px', background:'#f4f5f7', overflow:'hidden', position:'relative' }}>
                {/* notch */}
                <div style={{ position:'absolute', top:0, left:'50%', transform:'translateX(-50%)', width:'86px', height:'17px',
                  background:'#111827', borderRadius:'0 0 11px 11px', zIndex:2 }}/>
                {/* app header */}
                <div style={{ background:'linear-gradient(135deg,#16a34a,#15803d)', padding:'26px 13px 13px', color:'#fff' }}>
                  <div style={{ fontSize:'10px', opacity:0.85 }}>Good morning</div>
                  <div style={{ fontSize:'14px', fontWeight:'800' }}>Radhika Carrier</div>
                </div>
                {/* stat tiles */}
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'7px', padding:'11px' }}>
                  {[['Active','12','#2563eb'],['To receive','₹1.38L','#16a34a'],['To pay','₹92.5K','#ea580c'],['Profit','₹74.3K','#16a34a']].map(function(t){
                    return (
                      <div key={t[0]} style={{ background:'#fff', borderRadius:'9px', padding:'8px 9px', border:'1px solid #eef2f5' }}>
                        <div style={{ fontSize:'8px', color:'#6b7280', fontWeight:'700', textTransform:'uppercase' }}>{t[0]}</div>
                        <div style={{ fontSize:'13px', fontWeight:'900', color:t[2] }}>{t[1]}</div>
                      </div>
                    );
                  })}
                </div>
                {/* trip rows */}
                <div style={{ padding:'0 11px' }}>
                  <div style={{ fontSize:'9px', fontWeight:'800', color:'#6b7280', marginBottom:'6px' }}>RECENT TRIPS</div>
                  {[['TP006','Delhi → Mumbai','#dcfce7','#15803d','Closed'],
                    ['TP005','Jaipur → Surat','#dbeafe','#1d4ed8','In transit'],
                    ['TP004','Agra → Kanpur','#fef3c7','#92400e','Created']].map(function(r){
                    return (
                      <div key={r[0]} style={{ background:'#fff', borderRadius:'9px', padding:'8px 9px', marginBottom:'6px', border:'1px solid #eef2f5' }}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:'6px' }}>
                          <span style={{ fontSize:'9px', fontWeight:'800', color:'#6b7280' }}>{r[0]}</span>
                          <span style={{ fontSize:'7.5px', fontWeight:'800', background:r[2], color:r[3], padding:'1px 6px', borderRadius:'20px' }}>{r[4]}</span>
                        </div>
                        <div style={{ fontSize:'10.5px', fontWeight:'700', color:'#111827', marginTop:'2px' }}>{r[1]}</div>
                      </div>
                    );
                  })}
                </div>
                {/* bottom bar */}
                <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'#fff', borderTop:'1px solid #eef2f5',
                  display:'flex', justifyContent:'space-around', padding:'9px 0', fontSize:'13px' }}>
                  <span>🏠</span><span>📦</span><span>💳</span><span>📊</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Text + buttons ── */}
          <div className="app-copy-lp">
            <div style={{ display:'inline-block', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'30px',
              padding:'5px 14px', fontSize:'11px', fontWeight:'700', color:'#15803d', marginBottom:'14px' }}>
              📱 No Play Store needed
            </div>

            <h2 style={{ fontSize:'32px', fontWeight:'900', color:'#111827', lineHeight:1.2, letterSpacing:'-0.6px', marginBottom:'12px' }}>
              Install TransportMaster<br/>on your phone
            </h2>

            <p style={{ fontSize:'14px', color:'#6b7280', lineHeight:1.75, marginBottom:'20px', maxWidth:'440px' }}>
              Add it to your home screen and it opens like a normal app — full screen,
              no browser bar. Nothing to download, and it updates by itself.
            </p>

            <ul style={{ listStyle:'none', padding:0, margin:'0 0 24px' }}>
              {[['⚡','Opens in one tap from your home screen'],
                ['🔄','Always the latest version, no updates to install'],
                ['💾','Takes almost no space on your phone']].map(function(x){
                return (
                  <li key={x[1]} style={{ display:'flex', gap:'9px', alignItems:'flex-start', marginBottom:'9px' }}>
                    <span style={{ fontSize:'14px', flexShrink:0 }}>{x[0]}</span>
                    <span style={{ fontSize:'13.5px', color:'#374151', lineHeight:1.6 }}>{x[1]}</span>
                  </li>
                );
              })}
            </ul>

            <div className="app-btns-lp" style={{ display:'flex', gap:'11px', flexWrap:'wrap' }}>
              <button onClick={installApp}
                style={{ display:'inline-flex', alignItems:'center', gap:'10px', padding:'13px 24px', minHeight:'52px',
                  borderRadius:'11px', border:'none', cursor:'pointer', whiteSpace:'nowrap',
                  background:'linear-gradient(135deg,#16a34a,#15803d)', color:'#fff',
                  boxShadow:'0 7px 20px rgba(22,163,74,0.32)' }}>
                <span style={{ fontSize:'21px' }}>{isIos ? '' : '⬇️'}</span>
                <span style={{ textAlign:'left' }}>
                  <span style={{ display:'block', fontSize:'9.5px', fontWeight:'600', opacity:0.85, letterSpacing:'0.4px' }}>
                    {isIos ? 'ADD TO HOME SCREEN' : 'GET IT ON YOUR PHONE'}
                  </span>
                  <span style={{ display:'block', fontSize:'15px', fontWeight:'800', lineHeight:1.2 }}>Install App</span>
                </span>
              </button>

              <button onClick={function(){ open('register'); }}
                style={{ display:'inline-flex', alignItems:'center', gap:'10px', padding:'13px 22px', minHeight:'52px',
                  borderRadius:'11px', border:'1.5px solid #e5e7eb', background:'#fff', cursor:'pointer',
                  color:'#374151', whiteSpace:'nowrap' }}>
                <span style={{ fontSize:'19px' }}>🚀</span>
                <span style={{ textAlign:'left' }}>
                  <span style={{ display:'block', fontSize:'9.5px', fontWeight:'600', color:'#6b7280', letterSpacing:'0.4px' }}>15 DAYS FREE</span>
                  <span style={{ display:'block', fontSize:'15px', fontWeight:'800', lineHeight:1.2 }}>Start Trial</span>
                </span>
              </button>
            </div>

            <div style={{ fontSize:'11.5px', color:'#6b7280', marginTop:'13px' }}>
              Works on Android and iPhone · Chrome, Safari, Edge
            </div>
          </div>
        </div>

        {/* iPhone ke liye steps — Apple install API deta hi nahi */}
        {showIosHelp && (
          <div
            style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', zIndex:9999,
              display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'8vh 16px 24px', overflowY:'auto' }}>
            <div style={{ background:'#fff', borderRadius:'16px', maxWidth:'380px', width:'100%', padding:'24px' }}>
              <div style={{ fontSize:'17px', fontWeight:'900', color:'#111827', marginBottom:'6px' }}>Install on iPhone</div>
              <p style={{ fontSize:'12.5px', color:'#6b7280', lineHeight:1.6, marginBottom:'18px' }}>
                Safari does not allow one-tap install, so it takes three steps:
              </p>
              {[['1','Tap the Share button at the bottom of Safari','⬆️'],
                ['2','Scroll down and tap "Add to Home Screen"','➕'],
                ['3','Tap "Add" — the icon appears on your home screen','✅']].map(function(st){
                return (
                  <div key={st[0]} style={{ display:'flex', gap:'12px', alignItems:'flex-start', marginBottom:'14px' }}>
                    <div style={{ width:'26px', height:'26px', flexShrink:0, borderRadius:'50%', background:'#16a34a', color:'#fff',
                      display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:'800' }}>{st[0]}</div>
                    <div style={{ fontSize:'13.5px', color:'#374151', lineHeight:1.55 }}>{st[2]} {st[1]}</div>
                  </div>
                );
              })}
              <button onClick={function(){ setShowIosHelp(false); }}
                style={{ width:'100%', padding:'12px', minHeight:'46px', borderRadius:'10px', border:'none',
                  background:'#16a34a', color:'#fff', fontSize:'14px', fontWeight:'800', cursor:'pointer', marginTop:'4px' }}>
                Got it
              </button>
            </div>
          </div>
        )}
      </section>
      )}

      {/* ═══ IMPORT ═══
          Replaces the old "4 easy steps" block. Steps described a
          process; this shows the two things people actually stall on —
          getting their existing lists in, and knowing where the money
          went. Both sections carry a screen, because a broker believes
          what he can see. */}
      <section id="import" aria-labelledby="import-heading" style={{ padding:'72px 5%', background:'#f8fafc' }}>
        <div style={{ maxWidth:'1080px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'40px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ Setup</div>
            <h2 id="import-heading" style={{ fontSize:'34px', fontWeight:'900', color:'#111827', letterSpacing:'-0.5px' }}>
              All Your Data In, In 10 Minutes
            </h2>
            <p style={{ fontSize:'15px', color:'#6b7280', marginTop:'12px', maxWidth:'620px', margin:'12px auto 0', lineHeight:1.7 }}>
              Parties, transporters, drivers and trucks import straight from Excel.
              No typing them in one by one.
            </p>
          </div>

          <div className="imp-grid-lp" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'32px', alignItems:'center' }}>

            <div style={{ minWidth:0 }}>
              {[
                ['📤', 'Upload your Excel file', 'Column names do not have to match ours. Party Name, NAME, Firm Name — all recognised.'],
                ['👀', 'See what will happen first', 'Nothing is saved until you confirm. Duplicates and problem rows are listed with their row numbers.'],
                ['🔗', 'Drivers link to transporters by name', 'Write the transporter name in the sheet. The link is made for you.'],
                ['✅', 'Confirm, and start working', 'Create your first trip the same day.']
              ].map(function(x, i){
                return (
                  <div key={x[0]} style={{ display:'flex', gap:'14px', marginBottom: i===3 ? 0 : '22px' }}>
                    <div style={{ width:'42px', height:'42px', borderRadius:'11px', background:'#f0fdf4',
                      border:'1px solid #bbf7d0', display:'flex', alignItems:'center', justifyContent:'center',
                      fontSize:'18px', flexShrink:0 }}>{x[0]}</div>
                    <div style={{ minWidth:0 }}>
                      <h3 style={{ fontSize:'15px', fontWeight:'800', color:'#111827', marginBottom:'4px' }}>{x[1]}</h3>
                      <p style={{ fontSize:'13px', color:'#6b7280', lineHeight:1.65 }}>{x[2]}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Import preview screen.
                role="img" with a label, because to a screen reader (and
                to Google) this is a picture built out of divs — without
                the label it reads as forty stray numbers. */}
            <div role="img"
              aria-label="Import preview in TransportMaster: 52 rows in the Excel file, 45 will import, 3 already exist, 2 cannot import, leaving 59 parties."
              style={{ borderRadius:'16px', overflow:'hidden', minWidth:0,
              boxShadow:'0 22px 54px rgba(15,23,42,0.13), 0 2px 8px rgba(15,23,42,0.06)',
              border:'1px solid #e5e7eb', background:'#fff' }}>

              {/* App bar, same brand mark as the product itself so the
                  screen reads as a real one and not a diagram. */}
              <div style={{ background:'linear-gradient(135deg,#0f172a,#1e293b)',
                padding:'12px 15px', display:'flex', alignItems:'center', gap:'9px' }}>
                <div style={{ width:'26px', height:'26px', borderRadius:'8px',
                  background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex',
                  alignItems:'center', justifyContent:'center', fontSize:'14px',
                  boxShadow:'0 3px 10px rgba(22,163,74,0.4)' }}>🚛</div>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:'11.5px', fontWeight:'800', color:'#fff', letterSpacing:'-0.2px' }}>TransportMaster</div>
                  <div style={{ fontSize:'9px', color:'rgba(255,255,255,0.5)' }}>Parties · Import</div>
                </div>
                <div style={{ marginLeft:'auto', display:'flex', gap:'4px' }}>
                  {['#ef4444','#f59e0b','#22c55e'].map(function(c){
                    return <div key={c} style={{ width:'7px', height:'7px', borderRadius:'50%', background:c, opacity:0.7 }}/>;
                  })}
                </div>
              </div>

              {/* File strip */}
              <div style={{ background:'#f8fafc', borderBottom:'1px solid #eef1f4',
                padding:'10px 15px', display:'flex', alignItems:'center', gap:'9px' }}>
                <span style={{ fontSize:'15px' }}>📗</span>
                <div style={{ minWidth:0, flex:1 }}>
                  <div style={{ fontSize:'11.5px', fontWeight:'700', color:'#374151' }}>parties-list.xlsx</div>
                  <div style={{ fontSize:'9.5px', color:'#6b7280' }}>52 rows · uploaded just now</div>
                </div>
                <span style={{ fontSize:'9px', fontWeight:'800', color:'#15803d',
                  background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'20px', padding:'3px 9px' }}>
                  ✓ READ
                </span>
              </div>

              <div style={{ padding:'15px' }}>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'9px', marginBottom:'13px' }}>
                  {[['Rows in file','52','#f8fafc','#e5e7eb','#111827'],
                    ['Will import','45','#f0fdf4','#bbf7d0','#15803d'],
                    ['Already exist','3','#fff7ed','#fed7aa','#ea580c'],
                    ['Cannot import','2','#fef2f2','#fecaca','#dc2626']].map(function(r){
                    return (
                      <div key={r[0]} style={{ background:r[2], border:'1px solid '+r[3],
                        borderRadius:'10px', padding:'10px 12px' }}>
                        <div style={{ fontSize:'9.5px', color:'#6b7280', fontWeight:'700', textTransform:'uppercase', letterSpacing:'0.3px' }}>{r[0]}</div>
                        <div style={{ fontSize:'20px', fontWeight:'900', color:r[4], lineHeight:1.2 }}>{r[1]}</div>
                      </div>
                    );
                  })}
                </div>

                <div style={{ background:'#fafbfc', border:'1px solid #eef1f4', borderRadius:'10px',
                  padding:'10px 12px', marginBottom:'12px' }}>
                  <div style={{ fontSize:'9.5px', fontWeight:'800', color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.4px', marginBottom:'7px' }}>
                    Needs your attention
                  </div>
                  {[['23','Party name is empty','#dc2626'],
                    ['7','Bharat Traders — same phone already saved','#ea580c'],
                    ['31','Shree Sai — repeated in this file','#ea580c']].map(function(r){
                    return (
                      <div key={r[0]} style={{ display:'flex', gap:'8px', padding:'3px 0', alignItems:'center' }}>
                        <span style={{ fontSize:'9px', fontWeight:'800', color:'#fff', background:r[2],
                          borderRadius:'4px', padding:'2px 6px', flexShrink:0 }}>Row {r[0]}</span>
                        <span style={{ fontSize:'11px', color:'#4b5563' }}>{r[1]}</span>
                      </div>
                    );
                  })}
                </div>

                <div style={{ background:'linear-gradient(135deg,#f0fdf4,#dcfce7)',
                  border:'1px solid #bbf7d0', borderRadius:'11px',
                  padding:'12px 14px', display:'flex', justifyContent:'space-between',
                  alignItems:'center', marginBottom:'12px' }}>
                  <span style={{ fontSize:'12px', color:'#15803d', fontWeight:'700' }}>After importing</span>
                  <span style={{ fontSize:'19px', fontWeight:'900', color:'#15803d' }}>59 parties</span>
                </div>

                <div style={{ background:'linear-gradient(135deg,#16a34a,#15803d)', borderRadius:'10px',
                  padding:'12px', textAlign:'center',
                  boxShadow:'0 6px 18px rgba(22,163,74,0.32)' }}>
                  <span style={{ fontSize:'13.5px', fontWeight:'800', color:'#fff' }}>Import 45 Parties</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ BANK MANAGEMENT ═══ */}
      <section id="accounts" aria-labelledby="accounts-heading" style={{ padding:'72px 5%', background:'#fff' }}>
        <div style={{ maxWidth:'1080px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'40px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ Accounts</div>
            <h2 id="accounts-heading" style={{ fontSize:'34px', fontWeight:'900', color:'#111827', letterSpacing:'-0.5px' }}>
              Know Which Account the Money Went Through
            </h2>
            <p style={{ fontSize:'15px', color:'#6b7280', marginTop:'12px', maxWidth:'640px', margin:'12px auto 0', lineHeight:1.7 }}>
              Tag every payment to a bank account or to cash. Pull a monthly or yearly
              statement in Excel and send it to your CA — with the trip against every entry.
            </p>
          </div>

          <div className="imp-grid-lp" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'32px', alignItems:'center' }}>

            {/* Statement screen */}
            <div role="img"
              aria-label="Bank statement in TransportMaster: HDFC Current account, opening 1,80,000 rupees, 1,05,500 in, 87,900 out, closing 1,97,600, with the LR number and route on every entry."
              style={{ borderRadius:'16px', overflow:'hidden', minWidth:0,
              boxShadow:'0 22px 54px rgba(15,23,42,0.13), 0 2px 8px rgba(15,23,42,0.06)',
              border:'1px solid #e5e7eb', background:'#fff' }}>

              <div style={{ background:'linear-gradient(135deg,#0f172a,#1e293b)',
                padding:'12px 15px', display:'flex', alignItems:'center', gap:'9px' }}>
                <div style={{ width:'26px', height:'26px', borderRadius:'8px',
                  background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex',
                  alignItems:'center', justifyContent:'center', fontSize:'14px',
                  boxShadow:'0 3px 10px rgba(22,163,74,0.4)' }}>🚛</div>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:'11.5px', fontWeight:'800', color:'#fff', letterSpacing:'-0.2px' }}>TransportMaster</div>
                  <div style={{ fontSize:'9px', color:'rgba(255,255,255,0.5)' }}>Accounts · Statement</div>
                </div>
                <span style={{ marginLeft:'auto', fontSize:'9px', fontWeight:'800', color:'#4ade80',
                  background:'rgba(22,163,74,0.18)', border:'1px solid rgba(34,197,94,0.3)',
                  borderRadius:'20px', padding:'4px 10px', whiteSpace:'nowrap' }}>
                  📥 EXCEL
                </span>
              </div>

              <div style={{ background:'#f8fafc', borderBottom:'1px solid #eef1f4',
                padding:'10px 15px', display:'flex', alignItems:'center', gap:'9px' }}>
                <span style={{ fontSize:'15px' }}>🏦</span>
                <div style={{ minWidth:0, flex:1 }}>
                  <div style={{ fontSize:'11.5px', fontWeight:'700', color:'#374151' }}>HDFC Current</div>
                  <div style={{ fontSize:'9.5px', color:'#6b7280' }}>A/c ••••1257 · 1 Aug to 31 Aug</div>
                </div>
              </div>

              {/* Opening / in / out / closing */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1px',
                background:'#eef1f4', borderBottom:'1px solid #eef1f4' }}>
                {[['Opening','₹1,80,000','#6b7280','#fff'],
                  ['In','₹1,05,500','#15803d','#f0fdf4'],
                  ['Out','₹87,900','#dc2626','#fef2f2'],
                  ['Closing','₹1,97,600','#111827','#fff']].map(function(x){
                  return (
                    <div key={x[0]} style={{ background:x[3], padding:'11px 5px', textAlign:'center' }}>
                      <div style={{ fontSize:'8.5px', fontWeight:'800', color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.4px' }}>{x[0]}</div>
                      <div style={{ fontSize:'12.5px', fontWeight:'900', color:x[2], marginTop:'3px' }}>{x[1]}</div>
                    </div>
                  );
                })}
              </div>

              <div style={{ padding:'6px 15px 14px' }}>
                {[['12 Aug','Shree Sai Carriers','LR2026/247 · Baroda → Noida · HR47F7957','+₹85,500','#15803d','#f0fdf4'],
                  ['13 Aug','Royal Freight','TP247 · Baroda → Noida · HR47F7957','−₹82,900','#dc2626','#fef2f2'],
                  ['20 Aug','Bharat Traders','LR2026/250 · Delhi → Mumbai · UP13AB5428','+₹20,000','#15803d','#f0fdf4']].map(function(r){
                  return (
                    <div key={r[0]+r[1]} style={{ display:'flex', justifyContent:'space-between',
                      gap:'10px', padding:'10px 0', borderBottom:'1px solid #f5f7f8', alignItems:'center' }}>
                      <div style={{ display:'flex', gap:'10px', minWidth:0, alignItems:'center' }}>
                        <div style={{ width:'30px', height:'30px', borderRadius:'9px', background:r[5],
                          display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
                          fontSize:'13px', color:r[4], fontWeight:'900' }}>
                          {r[3][0] === '+' ? '↓' : '↑'}
                        </div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontSize:'12px', fontWeight:'800', color:'#111827' }}>{r[1]}</div>
                          <div style={{ fontSize:'10px', color:'#6b7280' }}>{r[0]} · {r[2]}</div>
                        </div>
                      </div>
                      <div style={{ fontSize:'13px', fontWeight:'900', color:r[4], flexShrink:0 }}>{r[3]}</div>
                    </div>
                  );
                })}

                <div style={{ marginTop:'11px', background:'linear-gradient(135deg,#16a34a,#15803d)',
                  borderRadius:'10px', padding:'11px', textAlign:'center',
                  boxShadow:'0 6px 18px rgba(22,163,74,0.3)' }}>
                  <span style={{ fontSize:'12.5px', fontWeight:'800', color:'#fff' }}>📥 Download Statement</span>
                </div>
              </div>
            </div>

            <div style={{ minWidth:0 }}>
              {[
                ['🏦', 'Every account in one place', 'Bank, cash and UPI. See the balance of each, and the total across all of them.'],
                ['🧾', 'Every entry says what it was for', 'Money in shows the LR number, route and vehicle. Money out shows the trip.'],
                ['📥', 'Monthly or yearly, in Excel', 'Pick the dates and download. Opening, in, out and closing all tie back.'],
                ['👨‍💼', 'Hand it to your CA as it is', 'Party name in its own column, so it can be sorted and filtered. No rework at year end.']
              ].map(function(x, i){
                return (
                  <div key={x[0]} style={{ display:'flex', gap:'14px', marginBottom: i===3 ? 0 : '22px' }}>
                    <div style={{ width:'42px', height:'42px', borderRadius:'11px', background:'#f0fdf4',
                      border:'1px solid #bbf7d0', display:'flex', alignItems:'center', justifyContent:'center',
                      fontSize:'18px', flexShrink:0 }}>{x[0]}</div>
                    <div style={{ minWidth:0 }}>
                      <h3 style={{ fontSize:'15px', fontWeight:'800', color:'#111827', marginBottom:'4px' }}>{x[1]}</h3>
                      <p style={{ fontSize:'13px', color:'#6b7280', lineHeight:1.65 }}>{x[2]}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ TESTIMONIALS ═══ */}
      <section style={{ padding:'72px 5%', background:'#fff' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'44px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ Testimonials</div>
            <h2 style={{ fontSize:'34px', fontWeight:'900', color:'#111827' }}>Trusted Across India</h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'20px' }} className="testi-grid-lp">
            {TESTIMONIALS.map(function(t){ return (
              <div key={t.name} style={{ background:'#f8fafc', borderRadius:'14px', padding:'22px', border:'1px solid #e5e7eb' }}>
                <div style={{ color:'#b45309', fontSize:'13px', marginBottom:'10px' }}>{'★'.repeat(t.stars)}</div>
                <p style={{ fontSize:'13px', color:'#374151', lineHeight:1.7, marginBottom:'16px', fontStyle:'italic' }}>"{t.text}"</p>
                <div style={{ display:'flex', alignItems:'center', gap:'10px', borderTop:'1px solid #e5e7eb', paddingTop:'12px' }}>
                  <div style={{ width:'36px', height:'36px', borderRadius:'50%', background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:'800', fontSize:'15px', flexShrink:0 }}>{t.name[0]}</div>
                  <div>
                    <div style={{ fontSize:'12px', fontWeight:'800', color:'#111827' }}>{t.name}</div>
                    <div style={{ fontSize:'10px', color:'#6b7280' }}>{t.role} · {t.city}</div>
                  </div>
                </div>
              </div>
            );})}
          </div>
        </div>
      </section>

      {/* ═══ PRICING ═══ */}
      <section id="pricing" style={{ padding:'72px 5%', background:'#f8fafc' }}>
        <div style={{ maxWidth:'900px', margin:'0 auto', textAlign:'center' }}>
          <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ Pricing</div>
          <h2 style={{ fontSize:'34px', fontWeight:'900', color:'#111827', marginBottom:'10px' }}>Simple, Affordable Plans</h2>
          <p style={{ fontSize:'14px', color:'#6b7280', marginBottom:'36px' }}>Start free. Upgrade when you grow.</p>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'16px', textAlign:'left' }} className="pricing-grid-lp">
            {(plans || PRICING).map(function(p, i){
              // Database plans and the fallback list have different shapes
              var live    = !!p.offer_active;
              var pop     = plans ? !!p.is_popular : !!p.highlight;
              var priceTx = plans ? ('₹' + Number(live ? p.final_price : p.price).toLocaleString('en-IN')) : p.price;
              var wasTx   = plans && live ? ('₹' + Number(p.price).toLocaleString('en-IN')) : null;
              var feats   = p.features || [];
              var cta     = plans ? (p.cta_label || 'Get Started') : p.cta;
              return (
              <div key={p.code || p.name || i} style={{ borderRadius:'14px', padding:'22px', border:pop?'2px solid #16a34a':'1px solid #e5e7eb', background:pop?'linear-gradient(135deg,#f0fdf4,#fff)':'#fff', position:'relative', boxShadow:pop?'0 10px 32px rgba(22,163,74,0.15)':'none' }}>
                {pop && <div style={{ position:'absolute', top:'-11px', left:'50%', transform:'translateX(-50%)', background:'linear-gradient(135deg,#16a34a,#22c55e)', color:'#fff', fontSize:'10px', fontWeight:'800', padding:'3px 12px', borderRadius:'20px', whiteSpace:'nowrap' }}>⭐ Most Popular</div>}

                {live && (
                  <div style={{ display:'inline-block', background:'#fef3c7', color:'#92400e', fontSize:'10px',
                    fontWeight:'800', padding:'3px 9px', borderRadius:'20px', marginBottom:'8px' }}>
                    🎉 {p.offer_label || (p.discount_percent + '% OFF')}
                  </div>
                )}

                <div style={{ fontSize:'11px', fontWeight:'700', color:'#6b7280', textTransform:'uppercase', marginBottom:'6px' }}>{p.name}</div>

                <div style={{ display:'flex', alignItems:'baseline', gap:'8px', marginBottom:'2px', flexWrap:'wrap' }}>
                  <span style={{ fontSize:'30px', fontWeight:'900', color:'#111827' }}>{priceTx}</span>
                  {wasTx && <span style={{ fontSize:'15px', fontWeight:'700', color:'#6b7280', textDecoration:'line-through' }}>{wasTx}</span>}
                </div>
                <div style={{ fontSize:'11px', color:'#6b7280', marginBottom: live ? '6px' : '18px' }}>{p.period}</div>

                {live && p.offer_ends && (
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#b45309', marginBottom:'14px' }}>
                    Offer ends {new Date(String(p.offer_ends).slice(0,10) + 'T00:00:00').toLocaleDateString('en-IN',{ day:'numeric', month:'short', year:'numeric' })}
                  </div>
                )}

                <ul style={{ listStyle:'none', marginBottom:'18px', display:'flex', flexDirection:'column', gap:'8px' }}>
                  {feats.map(function(f){ return (
                    <li key={f} style={{ fontSize:'12px', color:'#374151', display:'flex', alignItems:'flex-start', gap:'7px' }}>
                      <span style={{ color:'#15803d', fontWeight:'700', flexShrink:0 }}>✓</span>{f}
                    </li>
                  );})}
                </ul>
                <button onClick={function(){ open('register'); }} style={{ width:'100%', padding:'12px', minHeight:'44px', borderRadius:'8px', border:pop?'none':'1.5px solid #e5e7eb', background:pop?'linear-gradient(135deg,#16a34a,#15803d)':'#fff', color:pop?'#fff':'#374151', fontSize:'12px', fontWeight:'800', cursor:'pointer' }}>
                  {cta} →
                </button>
              </div>
            );})}
          </div>
        </div>
      </section>

      {/* ═══ FAQ ═══ */}
      <section id="faq" style={{ padding:'72px 5%', background:'#fff' }}>
        <div style={{ maxWidth:'680px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'44px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#15803d', textTransform:'uppercase', letterSpacing:'1.5px', marginBottom:'10px' }}>✦ FAQ</div>
            <h2 style={{ fontSize:'34px', fontWeight:'900', color:'#111827' }}>Frequently Asked Questions</h2>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
            {FAQS.map(function(f,i){ return (
              <div key={i} style={{ border:'1px solid #e5e7eb', borderRadius:'10px', overflow:'hidden' }}>
                <button onClick={function(){ setFaqOpen(faqOpen===i?null:i); }}
                  aria-expanded={faqOpen===i} aria-controls={'faq-body-'+i}
                  style={{ width:'100%', minHeight:'48px', padding:'14px 18px', background:faqOpen===i?'#f0fdf4':'#fff', border:'none', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', textAlign:'left' }}>
                  <span style={{ fontSize:'13px', fontWeight:'700', color:'#111827' }}>{f.q}</span>
                  <span style={{ fontSize:'18px', color:'#15803d', flexShrink:0, marginLeft:'10px', display:'inline-block', transform:faqOpen===i?'rotate(45deg)':'none', transition:'transform 0.2s' }}>+</span>
                </button>
                {faqOpen===i && (
                  <div id={'faq-body-'+i} style={{ padding:'4px 18px 14px', background:'#f0fdf4' }}>
                    <p style={{ fontSize:'12px', color:'#6b7280', lineHeight:1.7 }}>{f.a}</p>
                  </div>
                )}
              </div>
            );})}
          </div>
        </div>
      </section>

      {/* ═══ CTA ═══ */}
      <section style={{ padding:'72px 5%', background:'linear-gradient(135deg,#111827,#1f2937)', textAlign:'center' }}>
        <div style={{ maxWidth:'560px', margin:'0 auto' }}>
          <div style={{ fontSize:'36px', marginBottom:'14px' }}>🚛</div>
          <h2 style={{ fontSize:'34px', fontWeight:'900', color:'#fff', marginBottom:'12px', letterSpacing:'-0.5px' }}>Ready to Transform Your Business?</h2>
          <p style={{ fontSize:'14px', color:'rgba(255,255,255,0.7)', marginBottom:'28px', lineHeight:1.7 }}>Join 10,000+ transport brokers &amp; transporters across India.</p>
          <button onClick={function(){ open('register'); }} style={{ padding:'14px 40px', borderRadius:'10px', background:'linear-gradient(135deg,#16a34a,#22c55e)', border:'none', color:'#fff', fontSize:'15px', fontWeight:'800', cursor:'pointer', boxShadow:'0 6px 24px rgba(22,163,74,0.4)' }}>
            Start Your Free Trial 🚀
          </button>
          <div style={{ marginTop:'14px', fontSize:'11px', color:'rgba(255,255,255,0.5)' }}>No credit card · 15-day free trial · Setup in 2 minutes</div>
        </div>
      </section>

      {/* ═══ FOOTER ═══ */}
      <footer id="contact" style={{ background:'#0f172a', padding:'32px 5%' }}>
        <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:'24px', marginBottom:'24px' }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'8px' }}>
                <span style={{ fontSize:'20px' }}>🚛</span>
                <span style={{ fontSize:'15px', fontWeight:'900', color:'#fff' }}>Transport<span style={{ color:'#15803d' }}>Master</span></span>
              </div>
              <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.5)', lineHeight:1.6 }}>
                India's #1 Transport Management Platform<br/>for Brokers &amp; Transporters
              </div>
            </div>
            {/* One office, one address. A Delhi branch was shown here
                earlier; there is no Delhi office, and a address nobody
                sits at costs more than it gains — Google checks every
                address it finds against the Business Profile. */}
            <div style={{ minWidth:0 }}>
              <div style={{ fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.68)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'10px' }}>Contact</div>

              <div style={{ background:'rgba(22,163,74,0.12)', border:'1px solid rgba(34,197,94,0.28)',
                borderRadius:'9px', padding:'11px 13px', marginBottom:'12px', maxWidth:'300px' }}>
                <div style={{ fontSize:'10px', fontWeight:'800', color:'#4ade80', letterSpacing:'0.8px', textTransform:'uppercase', marginBottom:'4px' }}>
                  🏢 Office
                </div>
                <div style={{ fontSize:'13px', color:'rgba(255,255,255,0.9)', lineHeight:1.65, fontWeight:'600' }}>
                  Mussoorie Gulawathi Road,<br/>
                  Industrial Area, Kapoorpur,<br/>
                  Thana Hapur, Ghaziabad 245101
                </div>
              </div>

              <div><a href="tel:+919318301956" style={{ display:'inline-flex', alignItems:'center', minHeight:'40px', fontSize:'13px', color:'rgba(255,255,255,0.7)', textDecoration:'none' }}>📞 +91 93183 01956</a></div>
              <div><a href="mailto:info@transportmaster.in" style={{ display:'inline-flex', alignItems:'center', minHeight:'40px', fontSize:'13px', color:'rgba(255,255,255,0.7)', textDecoration:'none' }}>✉️ info@transportmaster.in</a></div>
              <div><a href="mailto:support@transportmaster.in" style={{ display:'inline-flex', alignItems:'center', minHeight:'40px', fontSize:'13px', color:'rgba(255,255,255,0.7)', textDecoration:'none' }}>🛟 support@transportmaster.in</a></div>
            </div>
            <div>
              <div style={{ fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.68)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'10px' }}>Product</div>
              {[{l:'Pricing',h:'/pricing'},
                {l:'Bilty / LR software',h:'/bilty-software'},
                {l:'Bilty format & number',h:'/bilty-format'},
                {l:'Lorry receipt (LR)',h:'/lorry-receipt-lr'},
                {l:'Truck types & capacity',h:'/truck-types-and-capacity'},
                {l:'Freight rate calculation',h:'/freight-rate-calculation'},
                {l:'Delete your account',h:'/delete-account'},
                {l:'Trip management',h:'/trip-management-software'},
                {l:'Party & supplier ledger',h:'/party-ledger-software'},
                {l:'Billing & invoices',h:'/transport-billing-software'},
                {l:'Coming from Excel',h:'/excel-se-transport-software'}].map(function(x){ var l=x.l; return (
                <div key={l}>
                  <a href={x.h} style={{ display:'inline-flex', alignItems:'center', minHeight:'34px', fontSize:'12px', color:'rgba(255,255,255,0.5)', textDecoration:'none' }}
                    onMouseEnter={function(e){e.target.style.color='#16a34a';}} onMouseLeave={function(e){e.target.style.color='rgba(255,255,255,0.5)';}}>
                    {l}
                  </a>
                </div>
              );})}
            </div>
            {/* Shehar wale page pehle sirf sitemap me the — site se ek
                bhi link nahi tha, isliye Google unhe zaroori nahi
                maanta tha. Ghar ka page sabse mazboot hai, isliye jod
                yahin se sabse zyada kaam karta hai. */}
            <div>
              <div style={{ fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.68)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'10px' }}>Cities</div>
              {[{l:'Delhi NCR',h:'/transport-software-in-delhi'},
                {l:'Mumbai',h:'/transport-software-in-mumbai'},
                {l:'Ahmedabad',h:'/transport-software-in-ahmedabad'},
                {l:'Jaipur',h:'/transport-software-in-jaipur'},
                {l:'Indore',h:'/transport-software-in-indore'},
                {l:'Ludhiana',h:'/transport-software-in-ludhiana'}].map(function(x){ var l=x.l; return (
                <div key={l}>
                  <a href={x.h} style={{ display:'inline-flex', alignItems:'center', minHeight:'34px', fontSize:'12px', color:'rgba(255,255,255,0.5)', textDecoration:'none' }}
                    onMouseEnter={function(e){e.target.style.color='#16a34a';}} onMouseLeave={function(e){e.target.style.color='rgba(255,255,255,0.5)';}}>
                    Transport software in {l}
                  </a>
                </div>
              );})}
            </div>
            <div>
              <div style={{ fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.68)', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'10px' }}>Links</div>
              {[{l:'Blog',h:'/blog'},{l:'Hinglish',h:'/hi/pricing'},{l:'Privacy Policy',h:'/privacy'},{l:'Terms of Service',h:'/terms'},{l:'Support',h:'/support'}].map(function(x){ var l=x.l; return (
                <div key={l}>
                  <a href={x.h} style={{ display:'inline-flex', alignItems:'center', minHeight:'42px', fontSize:'12px', color:'rgba(255,255,255,0.5)', textDecoration:'none' }}
                    onMouseEnter={function(e){e.target.style.color='#16a34a';}} onMouseLeave={function(e){e.target.style.color='rgba(255,255,255,0.5)';}}>
                    {l}
                  </a>
                </div>
              );})}
            </div>
          </div>
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.1)', paddingTop:'20px', display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:'10px' }}>
            <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.62)' }}>© 2026 TransportMaster · Made with ❤️ in India 🇮🇳</div>
            <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.62)' }}>transportmaster.in</div>
          </div>
        </div>
      </footer>

      {/* ═══ LOGIN/REGISTER POPUP ═══ */}
      {popup && (
        <div style={{ position:'fixed', inset:0, zIndex:9999 }}>
          {/* Bahar/side click se popup band NAHI hoga — sirf ✕ button se band hoga */}
          <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.55)', WebkitBackdropFilter:'blur(6px)', backdropFilter:'blur(6px)' }}/>
          <div role="dialog" aria-modal="true" aria-label="Login ya account banayein" style={{ position:'absolute', right:0, top:0, bottom:0, width:'min(420px,100vw)', background:'#fff', boxShadow:'-16px 0 50px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflowY:'auto' }}>

            {/* Popup header */}
            <div style={{ padding:'20px 24px', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #f3f4f6' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                <div style={{ width:'32px', height:'32px', borderRadius:'8px', background:'linear-gradient(135deg,#16a34a,#22c55e)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'16px' }}>🚛</div>
                <div style={{ fontSize:'16px', fontWeight:'900', color:'#111827' }}>Transport<span style={{ color:'#15803d' }}>Master</span></div>
              </div>
              <button onClick={close} aria-label="Close" style={{ width:'40px', height:'40px', borderRadius:'7px', background:'#f3f4f6', border:'none', cursor:'pointer', fontSize:'13px', color:'#6b7280' }}>✕</button>
            </div>

            {/* Tabs */}
            <div style={{ display:'flex', borderBottom:'1px solid #e5e7eb' }}>
              {['login','register'].map(function(t){ return (
                <button key={t} onClick={function(){ setTab(t); setError(''); }}
                  style={{ flex:1, padding:'12px', minHeight:'46px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight:'700', background:'#fff',
                    color: tab===t ? '#16a34a' : '#6b7280',
                    borderBottom: tab===t ? '2px solid #16a34a' : '2px solid transparent',
                    transition:'all 0.15s' }}>
                  {t==='login' ? 'Login' : 'Sign Up'}
                </button>
              );})}
            </div>

            <div style={{ padding:'24px', flex:1 }}>

              {/* TRIAL / SUBSCRIPTION KHATAM */}
              {expired && (
                <div>
                  <div style={{ fontSize:'40px', marginBottom:'10px' }}>⏰</div>
                  <h2 style={{ fontSize:'20px', fontWeight:'900', color:'#111827', marginBottom:'6px' }}>
                    {expired.isTrial ? 'Your free trial has ended' : 'Your subscription has ended'}
                  </h2>
                  <p style={{ fontSize:'13px', color:'#6b7280', lineHeight:1.7, marginBottom:'18px' }}>
                    {expired.name ? expired.name + ', your' : 'Your'}
                    {expired.isTrial ? ' 15-day free trial ' : ' subscription '}
                    ended <b>{expired.days} days ago</b>.
                    Pick a plan to carry on using TransportMaster.
                  </p>

                  <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'10px', padding:'14px', marginBottom:'18px' }}>
                    <div style={{ fontSize:'12.5px', fontWeight:'700', color:'#166534', marginBottom:'6px' }}>
                      Your data is completely safe
                    </div>
                    <div style={{ fontSize:'12px', color:'#166534', lineHeight:1.65 }}>
                      Trips, ledger, bilty — nothing has been deleted. It will all
                      be exactly where you left it.
                    </div>
                  </div>

                  <a href="tel:+919318301956"
                    style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'8px',
                      padding:'13px', minHeight:'48px', borderRadius:'10px', textDecoration:'none',
                      background:'linear-gradient(135deg,#16a34a,#15803d)', color:'#fff',
                      fontSize:'14px', fontWeight:'800', marginBottom:'10px' }}>
                    📞 Call us — +91 93183 01956
                  </a>
                  <a href="https://wa.me/919318301956"
                    style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'8px',
                      padding:'12px', minHeight:'46px', borderRadius:'10px', textDecoration:'none',
                      background:'#fff', border:'1.5px solid #e5e7eb', color:'#374151',
                      fontSize:'13px', fontWeight:'700', marginBottom:'16px' }}>
                    💬 Chat on WhatsApp
                  </a>

                  <button onClick={function(){ setExpired(null); }}
                    style={{ width:'100%', padding:'10px', minHeight:'42px', background:'none', border:'none',
                      color:'#6b7280', fontSize:'12.5px', fontWeight:'600', cursor:'pointer' }}>
                    ← Sign in with a different account
                  </button>
                </div>
              )}

              {/* LOGIN FORM */}
              {tab==='login' && !expired && (
                <div>
                  <h2 style={{ fontSize:'20px', fontWeight:'900', color:'#111827', marginBottom:'4px' }}>Welcome back!</h2>
                  <p style={{ fontSize:'12px', color:'#6b7280', marginBottom:'22px' }}>Login to your TransportMaster account</p>
                  <form onSubmit={handleLogin} style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
                    <div>
                      <label htmlFor="lp-login-phone" style={LBL}>Mobile Number</label>
                      <div style={{ display:'flex', borderRadius:'10px', border:'1.5px solid #e5e7eb', overflow:'hidden' }}>
                        <div style={{ padding:'13px 12px', background:'#f9fafb', fontSize:'13px', fontWeight:'700', color:'#374151', borderRight:'1.5px solid #e5e7eb' }}>+91</div>
                        <input id="lp-login-phone" name="phone" value={phone} onChange={function(e){setPhone(e.target.value.replace(/\D/g,'').slice(0,10));setError('');}}
                          placeholder="10-digit mobile" type="tel" inputMode="numeric" autoComplete="tel" maxLength={10} autoFocus
                          style={{ flex:1, padding:'13px 12px', border:'none', outline:'none', fontSize:'14px', fontFamily:'inherit', background:'#fff' }}/>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="lp-login-pass" style={LBL}>Password</label>
                      <div style={{ position:'relative' }}>
                        <input id="lp-login-pass" name="password" value={password} onChange={function(e){setPassword(e.target.value);setError('');}}
                          type={showPass?'text':'password'} placeholder="Enter password" autoComplete="current-password"
                          style={{ ...INP, paddingRight:'48px' }}/>
                        <button type="button" onClick={function(){setShowPass(!showPass);}}
                          aria-label={showPass?'Password chhupao':'Password dikhao'}
                          style={{ position:'absolute', right:'6px', top:'50%', transform:'translateY(-50%)', width:'40px', height:'40px', background:'none', border:'none', cursor:'pointer', fontSize:'15px', color:'#6b7280' }}>
                          {showPass?'🙈':'👁️'}
                        </button>
                      </div>
                    </div>
                    {error && <div role="alert" style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'8px', padding:'9px 12px', fontSize:'12px', color:'#b91c1c', fontWeight:'600' }}>⚠️ {error}</div>}
                    <button type="submit" disabled={loading} style={{ ...BTN_G, opacity:loading?0.6:1, cursor:loading?'not-allowed':'pointer' }}>
                      {loading?'Logging in...':'Login →'}
                    </button>
                  </form>
                  <div style={{ textAlign:'center', marginTop:'16px', fontSize:'12px', color:'#6b7280' }}>
                    Don't have account?{' '}
                    <button onClick={function(){setTab('register');setError('');}} style={{ background:'none', border:'none', color:'#15803d', fontWeight:'700', cursor:'pointer', fontSize:'12px' }}>
                      Sign Up Free
                    </button>
                  </div>


                </div>
              )}

              {/* REGISTER FORM */}
              {tab==='register' && !expired && (
                <div>
                  <h2 style={{ fontSize:'20px', fontWeight:'900', color:'#111827', marginBottom:'4px' }}>Create Account</h2>
                  <p style={{ fontSize:'12px', color:'#6b7280', marginBottom:'22px' }}>Start your 15-day free trial — no credit card needed</p>
                  <form onSubmit={handleRegister} style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
                    <div>
                      <label htmlFor="lp-reg-name" style={LBL}>Your Name *</label>
                      <input id="lp-reg-name" name="name" value={name} onChange={function(e){setName(e.target.value);setError('');}} placeholder="Rajesh Agarwal" autoComplete="name" autoFocus style={INP}/>
                    </div>
                    <div>
                      <label htmlFor="lp-reg-phone" style={LBL}>Mobile Number *</label>
                      <div style={{ display:'flex', borderRadius:'10px', border:'1.5px solid #e5e7eb', overflow:'hidden' }}>
                        <div style={{ padding:'13px 12px', background:'#f9fafb', fontSize:'13px', fontWeight:'700', color:'#374151', borderRight:'1.5px solid #e5e7eb' }}>+91</div>
                        <input id="lp-reg-phone" name="phone" value={phone} onChange={function(e){setPhone(e.target.value.replace(/\D/g,'').slice(0,10));setError('');}}
                          placeholder="10-digit mobile" type="tel" inputMode="numeric" autoComplete="tel" maxLength={10}
                          style={{ flex:1, padding:'13px 12px', border:'none', outline:'none', fontSize:'14px', fontFamily:'inherit', background:'#fff' }}/>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="lp-reg-pass" style={LBL}>Password *</label>
                      <input id="lp-reg-pass" name="new-password" value={password} onChange={function(e){setPassword(e.target.value);setError('');}}
                        type={showPass?'text':'password'} placeholder="Min 6 characters" autoComplete="new-password" style={INP}/>
                    </div>
                    <div>
                      <label htmlFor="lp-reg-co" style={LBL}>Company Name <span style={{ color:'#6b7280', textTransform:'none', fontWeight:'400' }}>(optional)</span></label>
                      <input id="lp-reg-co" name="organization" value={company} onChange={function(e){setCompany(e.target.value);}} placeholder="Agarwal Transport Co." autoComplete="organization" style={INP}/>
                    </div>
                    {error && <div role="alert" style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'8px', padding:'9px 12px', fontSize:'12px', color:'#b91c1c', fontWeight:'600' }}>⚠️ {error}</div>}
                    <button type="submit" disabled={loading||!name.trim()||phone.length<10||password.length<6}
                      style={{ ...BTN_G, opacity:loading||!name.trim()||phone.length<10||password.length<6?0.5:1, cursor:loading||!name.trim()||phone.length<10||password.length<6?'not-allowed':'pointer' }}>
                      {loading?'Creating Account...':'Create Account & Start Free Trial 🎉'}
                    </button>
                    <div style={{ textAlign:'center', fontSize:'11px', color:'#6b7280' }}>By signing up you agree to our Terms &amp; Privacy Policy</div>
                  </form>
                  <div style={{ textAlign:'center', marginTop:'14px', fontSize:'12px', color:'#6b7280' }}>
                    Already have account?{' '}
                    <button onClick={function(){setTab('login');setError('');}} style={{ background:'none', border:'none', color:'#15803d', fontWeight:'700', cursor:'pointer', fontSize:'12px' }}>
                      Login here
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 1024px) {
          .hero-grid-lp { grid-template-columns: 1fr !important; }
          /* The laptop mockup does not fit a phone, but hiding the whole
             block hid the phone screen too — and the phone is the part
             that matters most to someone reading this on a phone. So the
             browser window goes and the handset stays, centred. */
          /* The laptop does not fit a phone, but hiding the whole block
             hid the handset too — and that is the part a phone reader
             needs to see. Everything goes except the phone, which is
             centred and made bigger. The laptop is now three stacked
             divs (lid, hinge, base), so all three have to go, not just
             the first. */
          .hero-mockup-lp { position: static !important; display: flex !important;
            justify-content: center !important; margin-top: 10px !important; }
          .hero-mockup-lp > div:not(.mock-phone) { display: none !important; }
          /* Widening the phone without scaling its contents made it
             squat again — 190x288 is 1:1.52, which reads as a tablet.
             Keep the built width and scale the whole thing instead, so
             the proportions survive. */
          .hero-mockup-lp .mock-phone {
            position: static !important; display: block !important;
            bottom: auto !important; left: auto !important; right: auto !important;
            margin: 0 auto !important;
            transform: scale(1.32); transform-origin: top center; }
          /* scale() does not change layout height, so the space the
             phone now occupies has to be reserved by hand. */
          .hero-mockup-lp { padding-bottom: 96px !important; }
          .features-grid-lp { grid-template-columns: 1fr 1fr !important; }
          /* Text and screen sit side by side on a desktop; on a phone
             they stack, screen first — the picture is what makes the
             claim believable, so it should not be below the fold. */
          .imp-grid-lp { grid-template-columns: 1fr !important; gap: 26px !important; }
          .steps-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .pricing-grid-lp { grid-template-columns: 1fr !important; max-width: 360px; margin: 0 auto; }
        }
        @media (max-width: 1100px) {
          .mock-float { display: none !important; }
        }
        @media (max-width: 900px) {
          .app-wrap-lp { grid-template-columns: 1fr !important; gap: 30px !important; }
          .app-copy-lp { text-align: center; }
          .app-copy-lp ul { display: inline-block; text-align: left; }
          .app-btns-lp { justify-content: center; }
        }
        @media (max-width: 768px) {
          .nav-links-lp { display: none !important; }
          .stats-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .testi-grid-lp { grid-template-columns: 1fr !important; }
          .features-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .steps-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .hero-grid-lp h1 { font-size: 32px !important; }

          /* Mockup mobile pe chhupa hai, toh 100vh aadha screen khali chhod deta tha */
          .hero-sec-lp { min-height: auto !important; padding-bottom: 20px !important; }
        }
        @media (max-width: 480px) {
          .app-btns-lp { flex-direction: column !important; }
          .app-btns-lp button { width: 100% !important; justify-content: center !important; }
          .app-copy-lp h2 { font-size: 25px !important; }
          .mock-side { display: none !important; }
          .mock-two  { grid-template-columns: 1fr !important; }
          .features-grid-lp { grid-template-columns: 1fr !important; }
          .steps-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .stats-grid-lp { grid-template-columns: 1fr 1fr !important; }
          .pricing-grid-lp { grid-template-columns: 1fr !important; }

          /* Nav 320-430px pe overflow ho raha tha aur buttons 2 line me toot rahe the */
          .nav-tag-lp  { display: none !important; }
          .nav-name-lp { font-size: 14px !important; }
          .nav-cta-lp button { padding: 9px 11px !important; font-size: 12px !important; }

          /* Hero ke dono CTA poori chaudai me, kabhi na toote */
          .hero-cta-lp { flex-direction: column !important; align-items: stretch !important; }
          .hero-cta-lp button { width: 100% !important; justify-content: center !important; }
        }
        @media (max-width: 380px) {
          /* Itni chhoti screen pe naam Login button ke neeche chala jaata tha — sirf logo */
          .nav-name-lp { display: none !important; }
          .nav-cta-lp { gap: 6px !important; }
          .nav-cta-lp button { padding: 9px 10px !important; }
        }
        @media (prefers-reduced-motion: reduce) {
          html { scroll-behavior: auto; }
          * { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
        }
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
        section[id] { scroll-margin-top: 78px; }
      `}</style>
    </div>
  );
}
